import {useNavigate, NavLink, useLocation} from 'react-router-dom';
import {LayoutDashboard, Plus, User} from 'lucide-react';
import {useUser} from 'contexts/UserContext';
import useIsAuthenticated from 'hooks/useIsAuthenticated';
import cn from 'helpers/cn';

function DefaultLayout({children}: LayoutProps) {
  const navigate = useNavigate();
  const {user} = useUser();
  const isAuthenticated = useIsAuthenticated(user, null, () => {
    navigate('/login');
  });
  const location = useLocation();

  const isAddPage = location.pathname === '/movement/add';

  const showBarLeft = isAddPage;

  if (!user || !isAuthenticated) {
    return null;
  }

  return (
    <div className='h-[100dvh] flex flex-col bg-background text-foreground overflow-hidden'>
      <main className='flex-1 overflow-y-auto no-scrollbar pb-32'>
        <div className='inner md:pt-6'>{children}</div>
      </main>

      {/* Floating Action Dock */}
      <div className='fixed bottom-6 left-0 right-0 z-50 pointer-events-none'>
        <nav
          className={cn(
            'inner flex',
            showBarLeft ? 'justify-start px-6' : 'justify-center',
          )}
        >
          <div className='glass flex items-center justify-between gap-8 px-8 py-3 rounded-full shadow-2xl transition-all duration-300 pointer-events-auto'>
            <NavLink
              to='/'
              className={({isActive}) =>
                cn(
                  'flex flex-col items-center gap-1 transition-all duration-200',
                  isActive
                    ? 'text-primary scale-110'
                    : 'text-muted-foreground hover:text-foreground',
                )
              }
            >
              {({isActive}) => (
                <>
                  <LayoutDashboard size={22} strokeWidth={isActive ? 2.5 : 2} />
                  <span className='text-[10px] font-medium'>Home</span>
                </>
              )}
            </NavLink>

            {!isAddPage && (
              <NavLink to='/movement/add' className='relative -mt-12 group'>
                <div className='flex items-center justify-center w-14 h-14 rounded-full bg-primary text-primary-foreground shadow-[0_8px_16px_rgba(0,0,0,0.2)] dark:shadow-[0_8px_16px_rgba(255,255,255,0.1)] group-active:scale-95 transition-transform duration-200'>
                  <Plus size={28} strokeWidth={3} />
                </div>
              </NavLink>
            )}

            <NavLink
              to='/profile'
              className={({isActive}) =>
                cn(
                  'flex flex-col items-center gap-1 transition-all duration-200',
                  isActive
                    ? 'text-primary scale-110'
                    : 'text-muted-foreground hover:text-foreground',
                )
              }
            >
              {({isActive}) => (
                <>
                  <User size={22} strokeWidth={isActive ? 2.5 : 2} />
                  <span className='text-[10px] font-medium'>User</span>
                </>
              )}
            </NavLink>
          </div>
        </nav>
      </div>
    </div>
  );
}

export default DefaultLayout;
